'use client';

import Link from '@eliadmin/core/src/components/link';

import type { TDynamicData } from '../../types/dynamic-data';

import { cn } from '@eliadmin/core/src/utils/style-utils';

import { GrDocumentText, GrPrint } from 'react-icons/gr';

interface MemberZoneFileProps {
  item: TDynamicData;
  showDownload?: boolean;
  showPrint?: boolean;
  showCreatedAt?: boolean;
}

export function MemberZoneFile({
  item,
  showDownload = true,
  showPrint = true,
}: MemberZoneFileProps) {
  return (
    <div
      className={cn(
        'ea-member-zone__file',
        'flex w-full items-center justify-between gap-2 bg-white p-5',
      )}
    >
      <div className="flex w-full flex-col items-start justify-start gap-2">
        <p className="text-sm font-bold text-primary sm:text-base">{item.name}</p>
      </div>
      <div className="flex items-center justify-end gap-2.5">
        {showDownload && (
          <Link
            prefetch={false}
            href={item?.fields?.[0]?.file?.url}
            target="_blank"
            rel="noopener noreferrer"
            className={cn('ea-member-zone-file__button')}
          >
            <GrDocumentText size={20} className="text-secondary" />
          </Link>
        )}
        {showPrint && (
          <Link
            prefetch={false}
            href={item?.fields?.[0]?.file?.url}
            target="_blank"
            rel="noopener noreferrer"
            className={cn('ea-member-zone-file__button')}
          >
            <GrPrint size={20} className="text-secondary" />
          </Link>
        )}
      </div>
    </div>
  );
}
